import { Box, Dialog, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/modules/common/components/Button/Button';

// TODO rename to confim dialog

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onDelete: () => void;
  deleteConfirmation: string;
  info: string;
  confirmText?: string;
  cancelText?: string;
  title?: string;
  matchingText?: string;
}

const ConfirmDialog = ({
  isOpen,
  isLoading,
  onClose,
  onDelete,
  deleteConfirmation,
  info,
  confirmText,
  cancelText,
  title,
  matchingText,
}: Props) => {
  const { t } = useTranslation();
  const [text, setText] = useState('');
  const [error, setError] = useState<string | undefined>(undefined);

  const handleDeleteClick = () => {
    if (matchingText === undefined) onDelete();
    else {
      if (text === matchingText) onDelete();
      else {
        setError(t('shared.components.confirmDialog.error'));
        return;
      }
    }
    setError(undefined);
  };

  return (
    <Dialog open={isOpen}>
      <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: '25px' }}>
        <Typography variant="h4">{title || t('shared.components.confirmDialog.title')}</Typography>
        <Typography variant="body1">{deleteConfirmation}</Typography>
        <Typography variant="body1">{info}</Typography>
        {matchingText && (
          <>
            <TextField
              inputProps={{
                form: { autoComplete: 'off' },
              }}
              fullWidth
              name="text"
              id="text"
              variant="outlined"
              value={text}
              onChange={(event: any) => {
                setText(event.target.value);
              }}
            />
            {error && (
              <Typography color="error">{t('messages.resetSurvey.unmatchedText')}</Typography>
            )}
          </>
        )}

        <Box display="flex" justifyContent="flex-end">
          <Button variant="outlined" size="small" onClick={onClose}>
            {cancelText || t('shared.components.confirmDialog.cancel')}
          </Button>
          <Button
            variant="contained"
            size="small"
            loading={isLoading}
            onClick={handleDeleteClick}
            sx={{ ml: 2 }}
          >
            {confirmText || t('shared.components.confirmDialog.confirm')}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ConfirmDialog;
